(function () {
  'use strict';
  var API = (document.documentElement.getAttribute('data-api') || 'https://front.4147r3yu.com').replace(/\/+$/, '') + '/api/remind';
  var DAYS = { tomorrow: 1, '3d': 3, '1w': 7, '2w': 14 };
  var MAX_AHEAD = 60;

  function ga(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }
  function todayEt() {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(new Date());
  }
  function addDays(ymd, n) {
    var d = new Date(ymd + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function daysBetween(a, b) {
    return Math.round((Date.parse(b + 'T12:00:00Z') - Date.parse(a + 'T12:00:00Z')) / 86400000);
  }
  function pretty(ymd) {
    return new Date(ymd + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function eligible(cart) {
    return (cart.items || []).filter(function (i) { return i.final_price > 0 && !i.gift_card; });
  }

  var params = new URLSearchParams(location.search);
  var restore = params.get('restore');
  if (restore) {
    var want = {};
    restore.split(',').slice(0, 30).forEach(function (pair) {
      var m = /^(\d{1,20}):(\d{1,2})$/.exec(pair);
      if (m && +m[2] > 0) want[m[1]] = Math.max(want[m[1]] || 0, +m[2]);
    });
    params.delete('restore');
    var q = params.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    getCart().then(function (cart) {
      var have = {}, haveLine = {};
      (cart.items || []).forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; haveLine[i.key] = i.quantity; });
      var adds = Object.keys(want).map(function (id) { return { id: +id, quantity: want[id] - (have[id] || 0) }; })
        .filter(function (a) { return a.quantity > 0; });
      var added = 0;
      return adds.reduce(function (p, a) {
        return p.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [a] }) })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
              var it = j && j.items && j.items[0];
              if (!it) return;
              if (it.final_price > 0 && !it.gift_card) { added += a.quantity; return; }
              return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: it.key, quantity: haveLine[it.key] || 0 }) });
            })
            .catch(function () {});
        });
      }, Promise.resolve()).then(function () { return added; });
    }).then(function (added) {
      ga('cart_remind_restored', { item_count: added });
      var c = window.AlatreyuCart;
      if (c) c.refresh().then(c.open); else location.href = '/cart';
    }).catch(function () {});
  }

  var root = document.querySelector('[data-cart-remind]');
  if (!root) return;
  var form = root.querySelector('[data-cart-remind-form]');
  var email = form.elements.email;
  var choice = root.querySelector('[data-cart-remind-choice]');
  var dateRow = root.querySelector('[data-cart-remind-date-row]');
  var dateIn = root.querySelector('[data-cart-remind-date]');
  var err = root.querySelector('[data-cart-remind-error]');
  var submit = root.querySelector('[data-cart-remind-submit]');
  var done = root.querySelector('[data-cart-remind-done]');
  var submitLabel = submit.textContent;
  var renderedAt = Date.now(), prevOverflow = '', opener = null, busy = false;

  function say(key) { err.textContent = root.getAttribute('data-err-' + key); err.hidden = false; }
  function open(btn) {
    opener = btn;
    var t = todayEt();
    dateIn.min = addDays(t, 1);
    dateIn.max = addDays(t, MAX_AHEAD);
    form.hidden = false; done.hidden = true; err.hidden = true;
    submit.textContent = submitLabel; submit.disabled = false;
    prevOverflow = document.documentElement.style.overflow;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    email.focus({ preventScroll: true });
    getCart().then(function (c) {
      ga('cart_remind_open', { item_count: eligible(c).reduce(function (n, i) { return n + i.quantity; }, 0) });
    }).catch(function () {});
  }
  function close() {
    root.hidden = true;
    document.documentElement.style.overflow = prevOverflow;
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remind-open]');
    if (btn) { e.preventDefault(); open(btn); }
  });
  root.querySelectorAll('[data-cart-remind-close]').forEach(function (b) { b.addEventListener('click', close); });
  root.addEventListener('click', function (e) { if (e.target === root) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) { e.stopPropagation(); close(); }
  }, true);
  choice.addEventListener('change', function () {
    dateRow.hidden = choice.value !== 'custom';
    if (!dateRow.hidden) dateIn.focus();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    err.hidden = true;
    var address = email.value.trim();
    if (!/^[^\s@<>"'`]+@[^\s@<>"'`]+\.[^\s@<>"'`]+$/.test(address)) { say('email'); email.focus(); return; }
    var today = todayEt();
    var day = choice.value === 'custom' ? dateIn.value : addDays(today, DAYS[choice.value] || 3);
    var ahead = day ? daysBetween(today, day) : 0;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day || '') || !(ahead >= 1 && ahead <= MAX_AHEAD)) { say('date'); if (choice.value === 'custom') dateIn.focus(); return; }
    busy = true;
    submit.disabled = true;
    submit.textContent = root.getAttribute('data-sending');
    var lines, value = 0, count = 0;
    getCart().then(function (cart) {
      lines = eligible(cart).map(function (i) {
        value += i.final_line_price / 100;
        count += i.quantity;
        return { variant_id: String(i.variant_id), quantity: i.quantity };
      });
      function post() {
        return fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: address, remind_on: day, choice: choice.value, lines: lines,
            website: form.elements.website.value, rendered_at: renderedAt
          })
        });
      }
      var wait = 3500 - (Date.now() - renderedAt);
      return wait > 0 ? new Promise(function (ok) { setTimeout(ok, wait); }).then(post) : post();
    }).then(function (res) {
      if (res.status === 201) {
        form.hidden = true;
        done.textContent = root.getAttribute('data-success').replace('[date]', pretty(day));
        done.hidden = false;
        ga('cart_remind_saved', { choice: choice.value, days_ahead: ahead, item_count: count, value: value, currency: 'USD' });
        return;
      }
      if (res.status === 429) return say('busy');
      return res.json().then(function (j) {
        say(/email/i.test((j && (j.error || j.message)) || '') ? 'email' : 'generic');
      }, function () { say('generic'); });
    }).catch(function () { say('generic'); }).then(function () {
      busy = false;
      submit.disabled = false;
      submit.textContent = submitLabel;
    });
  });
})();
